import React, { FC } from 'react'
import { ThreePsCategorizedCodes } from '../../../../../Models/applicationModels'
import { ThreePsSection } from './components/threePsSection/threePsSection.index'

interface IThreePsCodeTableProps {
    tableData?: { [key: string]: ThreePsCategorizedCodes[] }
}

export const ThreePsCodeTable: FC<IThreePsCodeTableProps> = ({ tableData }) => {
    if (!tableData) return null

    return (
        <>
            {Object.entries(tableData).map(([key, entries]) => (
                <ThreePsSection key={key} sectionKey={key} entries={entries} />
            ))}
        </>
    )
}
